import { useState } from "react";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Login failed");
        return;
      }

      localStorage.setItem("auth_token", data.token);
      localStorage.setItem("auth_email", data.email);
      onLogin(data.token);
    } catch {
      setError("Could not connect to server");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0F0F1A",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Georgia', serif",
        padding: 20,
      }}
    >
      <div style={{ width: "100%", maxWidth: 380 }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🏃</div>
          <div style={{ color: "#fff", fontSize: 22, fontWeight: "bold" }}>Marathon Training</div>
          <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 13, marginTop: 4 }}>
            19-week plan · Futóest 10.55km
          </div>
        </div>

        {/* Form */}
        <div
          style={{
            background: "#1A1A2E",
            borderRadius: 14,
            padding: 28,
            border: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <div
            style={{
              color: "rgba(255,255,255,0.6)",
              fontSize: 12,
              letterSpacing: 1,
              marginBottom: 20,
              fontFamily: "monospace",
            }}
          >
            SIGN IN
          </div>

          {error && (
            <div
              style={{
                background: "#C0392B22",
                border: "1px solid #C0392B55",
                borderRadius: 8,
                padding: "10px 14px",
                marginBottom: 16,
                color: "#E74C3C",
                fontSize: 13,
              }}
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 14 }}>
              <label
                style={{
                  display: "block",
                  color: "rgba(255,255,255,0.5)",
                  fontSize: 11,
                  marginBottom: 6,
                  letterSpacing: 1,
                  fontFamily: "monospace",
                }}
              >
                EMAIL
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoComplete="email"
                style={{
                  width: "100%",
                  background: "#0F0F1A",
                  border: "1px solid rgba(255,255,255,0.12)",
                  borderRadius: 8,
                  padding: "11px 14px",
                  color: "#fff",
                  fontSize: 14,
                  fontFamily: "'Georgia', serif",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label
                style={{
                  display: "block",
                  color: "rgba(255,255,255,0.5)",
                  fontSize: 11,
                  marginBottom: 6,
                  letterSpacing: 1,
                  fontFamily: "monospace",
                }}
              >
                PASSWORD
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                style={{
                  width: "100%",
                  background: "#0F0F1A",
                  border: "1px solid rgba(255,255,255,0.12)",
                  borderRadius: 8,
                  padding: "11px 14px",
                  color: "#fff",
                  fontSize: 14,
                  fontFamily: "'Georgia', serif",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "13px",
                background: loading ? "#333" : "#E8650A",
                border: "none",
                borderRadius: 8,
                color: "#fff",
                fontSize: 15,
                fontWeight: "bold",
                fontFamily: "'Georgia', serif",
                cursor: loading ? "default" : "pointer",
              }}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
